// @flow

import {
	SelectBaseStrategy,
} from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import type { ISelectStrategy } from 'rgs-nfd-ui-kit/ko-components/select/index.flow';
import type {
	SettlementDetailModel,
	SettlementShortModel,
} from 'app-my-account/services/kladr/api-models/kladr.flow';
import ko from 'rgs-knockout';
import type { SelectBaseStrategyOptions } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import { AddressSettlement } from 'app-my-account/models/address';
import _ from "lodash";

export type StrategySettlementsOptions = SelectBaseStrategyOptions<SettlementShortModel> & {
	settlement: AddressSettlement,
	onClickItem: (kladr: string)=>Promise<void>,
	onClickCancel: ()=>void,
	onChangeCurrentValue: ()=>Promise<*>,
}

export class StrategySettlements extends SelectBaseStrategy<SettlementShortModel>
	implements ISelectStrategy<SettlementShortModel> {

	withSearch = ko.observable(true);
	pathToId = 'Kladr';
	pathToName = 'FullName';
	minLengthSearchWord = 1;

	_options: StrategySettlementsOptions;

	async onClickItem (settlement: SettlementShortModel) {
		const oldValue = this.currentValue();
		const isRealChange = _.isEqual(oldValue, settlement);

		await super.onClickItem(settlement);

		await this._options.onClickItem(this.getCurrentId());

		if (isRealChange) {
			await this._options.onChangeCurrentValue();
		}
	}

	setCurrentSettlement (settlement: SettlementShortModel | SettlementDetailModel) {
		this.currentValue(settlement);
	}

	onClickCancel () {
		super.onClickCancel();

		this._options.onClickCancel();
	}
}
